import React, { Suspense, lazy, useEffect } from 'react';
import { Routes, BrowserRouter as Router, Route, useLocation, Navigate } from 'react-router-dom';
import logo from './logo.svg';
import './App.scss';
// import './index.css';
import Footer from './Footer';
import Navbar from './Navbar'; 
import SideMenu from './SideMenu.js';
import './scss/font.scss';

import Login from './login/BasicLogin';
import SignUp from './login/SignUp';
import AccountRecovery from './login/AccountRecovery';
import CreatPw from './login/CreatePw';
import UpdateApp from './login/UpdateApp';


import Board from './page_board/Board';
import StoreBook from './page_storeBook/StoreBook';
import ChatRoomListPage from './page_firebase/ChatRoomListPage';
import ChatWindowPage from './page_firebase/ChatWindowPage';
import GuestLogin from './login/GuestLogin.js';
import DirectMessageTest from './page_firebase/DirectMessageTest';
import DirectMessageApp from './page_firebase/directMessage/DirectMessageApp';
import AiStudy from './page_aiStudy/AiStudy';
import AiEssay from './page_aiEssay';
import MenuPage from './page_menu/MenuPage';
import DigitalLms from './page_digitalLms/DigitalLms';
import LmsLearningReport from './page_lmsReport/LmsLearningReport';
import Scheduler from './page_scheduler';
import GuardianScheduler from './page_scheduler/GuardianScheduler';
import AiMediaOn from './page_aiMediaOn';
import WalletPage from './billing/WalletPage';
import PersonalLearningRoute from './mymod/PersonalLearningRoute';
import { isParentAccount } from './mymod/accountRole';

import { useSelector, useDispatch } from 'react-redux';
import {Container} from './scss/theme';
import { setVersion, setIsLoginPage } from './reduxToolkit/redux';

const TeacherWorkspace = lazy(() => import('./teacherLms/TeacherWorkspace'));
const StudentQuestionBank = lazy(() => import('./studentQuestionBank/StudentQuestionBank'));






function App() {

  const dispatch = useDispatch();
  const location = useLocation(); // 현재 경로를 얻기 위해 useLocation 훅 사용
  const isLoggedIn = useSelector(state => state.reduxStore.isLoggedIn);
  
  // window.AppVersion_ios = (version) => {
  //   alert(version);
  //   if (version){
    
  //     dispatch(setVersion(version));
  //   }
  // // };
  const version = localStorage.getItem('AppVersion');
  const deviceInfo = localStorage.getItem('DeviceInfo');
  const fcmToken = localStorage.getItem('FcmToken');

  useEffect(() => {
    if (version){
          dispatch(setVersion(version));
    }
  }, [version]);

  
 useEffect(() => {
  if (deviceInfo) {
    try {
      const obj = JSON.parse(deviceInfo);
      if (obj?.vendorID) {
        // alert(obj.vendorID);
      } else {
        console.warn("venderID가 존재하지 않습니다.", obj);
      }
    } catch (error) {
      console.error("JSON 파싱 오류:", error);
    }
  }
}, [deviceInfo]);

useEffect(() => {
  if (fcmToken){
      
  }
}, [fcmToken]);

 

  
  // window.AppVersion = (version) => {
  //   if (version){
  //     dispatch(setVersion(version));
  //   }
  // };

  
  //-------------------------------------------------------------최신 업데이트
  useEffect(() => {//잘 안 되면 build 폴더를 지우고 추가해봐(앞으로 빼서 그런지 되긴 한다.)

    const currentVersion = localStorage.getItem('updateVersion');
    const newVersion = '1.0.35';

    if (currentVersion !== newVersion) {
      localStorage.setItem('updateVersion', newVersion); 
      window.location.reload(true); // 강제 새로고침, 사파리는 어떤지 확인 필요
    }
  }, []);

  useEffect(() => {
    // 현재 경로가 로그인 관련 경로인지 확인
    if (location.pathname === '/' || location.pathname === '/login') {
      dispatch(setIsLoginPage(true));
    } else {
      dispatch(setIsLoginPage(false));
    }
  }, [location.pathname, dispatch]);

    
  const hideLayoutPaths = ['/fileDownloadWebpage']; // 레이아웃 숨길 경로 리스트
  const isLayoutHidden = hideLayoutPaths.includes(location.pathname);


  //==============================================
  return (
    <div className="App">

      {/* <Navbar /> */}

      <div className="app-layout">
  
          {/* {isLoggedIn && <SideMenu />} */}
          <div className="main-content">
          <Container>
            <Routes>
            
              <Route path="/creatpw" element={<CreatPw />} />
              <Route path="/updatepw" element={<Navigate to="/findPw" replace />} />
              <Route path="/updateapp" element={<UpdateApp />} />
              <Route path="/" element={<Login />} />
            
          
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/findId" element={<AccountRecovery key="find-id" mode="id" />} />
              <Route path="/findPw" element={<AccountRecovery key="find-password" mode="password" />} />
              <Route path="/findPwUpdate" element={<Navigate to="/findPw" replace />} />
              <Route path="/naver-callback" element={<GuestLogin />} />
              <Route path="/login/google/callback" element={<GuestLogin />} />

              <Route path="/board" element={<Board />} />
              <Route path="/storeBook" element={<StoreBook />} />
              <Route path="/chatrooms" element={<ChatRoomListPage />} />
              <Route path="/chatRoomListPage" element={<ChatRoomListPage />} />
              <Route path="/talk" element={<ChatRoomListPage />} />
              <Route path="/chat/:chatroomId" element={<ChatWindowPage />} />
              <Route path="/chatWindowPage/:chatroomId" element={<ChatWindowPage />} />
              <Route path="/guest-login" element={<GuestLogin />} />
              <Route path="/direct-message-test" element={<DirectMessageTest />} />
              <Route path="/directMessageApp" element={<DirectMessageApp />} />
              <Route path="/talk-send" element={<DirectMessageApp />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/teacher-lms/*" element={<Suspense fallback={<div role="status" style={{ padding: '3rem', color: '#254841' }}>선생님 LMS를 불러오고 있습니다.</div>}><TeacherWorkspace /></Suspense>} />
              <Route path="/wallet" element={<PersonalLearningRoute><WalletPage /></PersonalLearningRoute>} />
              <Route path="/aiStudy" element={<PersonalLearningRoute><AiStudy /></PersonalLearningRoute>} />
              <Route path="/aiEssay" element={<PersonalLearningRoute><AiEssay /></PersonalLearningRoute>} />
              <Route path="/lms" element={<PersonalLearningRoute parentPath="/lms/report"><DigitalLms /></PersonalLearningRoute>} />
              <Route path="/lms/question-bank/*" element={<PersonalLearningRoute parentPath="/lms/report"><Suspense fallback={<div role="status">문제은행을 불러오고 있습니다.</div>}><StudentQuestionBank /></Suspense></PersonalLearningRoute>} />
              <Route path="/lms/report" element={<LmsLearningReport />} />
              <Route path="/scheduler" element={<PersonalLearningRoute parentPath="/scheduler/children"><Scheduler /></PersonalLearningRoute>} />
              <Route path="/scheduler/children" element={isParentAccount() ? <GuardianScheduler /> : <Navigate to="/scheduler" replace />} />
              <Route path="/aiMediaOn" element={<PersonalLearningRoute><AiMediaOn /></PersonalLearningRoute>} />
            </Routes>
          </Container>
          </div>
   
      </div>








       
      {/* <Navbar /> */}
      {/* <div className="box_routes"> */}
        {/* <Container> */}
            {/* <Routes> */}
    
              {/* <Route path="/evaluationTec" element={<EvaluationTec />} />
              <Route path="/gradeView" element={<GradeView />} />

              <Route path="/creatpw" element={<CreatPw />} />
              <Route path="/updatepw" element={<UpdatePw />} />
              <Route path="/updateapp" element={<UpdateApp />} />

              <Route path="/" element={<HomeApp />} />
          
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />

              <Route path="/homeApp" element={<HomeApp />} />
              <Route path="/digital" element={<Digital />} />
              <Route path="/book" element={<Book />} />
              <Route path="/exam" element={<Exam />} />
              <Route path="/courseRegTec" element={<CourseRegTec />} />
              <Route path="/courseReg" element={<CourseReg />} />
              <Route path="/BasicSetting" element={<BasicSetting />} />
              <Route path="/LmsTec" element={<LmsTec />} />
              <Route path="/Lms" element={<Lms />} />
              <Route path="/LmsTecResultApp" element={<LmsTecResultApp />} />

              <Route path="/combobox" element={<Combobox />} />
              <Route path="/drawMenu" element={<DrawMenu />} />

              <Route path="/downloadNewWindow" element={<Download_newWindow />} />

              <Route path="/findPw" element={<FindPw />} />
              <Route path="/findPwUpdate" element={<FindPw_update />} />
              <Route path="/findId" element={<FindId />} />
              <Route path="/deleteId" element={<DeleteId />} />
              <Route path="/boardDetail" element={<BoardDetail />} />
              <Route path="/fileDownloadWebpage" element={<FileDownloadWebpage />} /> */}
            {/* </Routes> */}
        {/* </Container> */}

      {/* </div> */}
      
    </div>
  );
}

export default App;
